import { useNavigate, useSearchParams } from 'react-router'

/**
 * Returns a navigate function that carries all current URL search params to the
 * destination, optionally appending extra key/value pairs on top.
 *
 * Usage:
 *   const navigateTo = useNavigateWithParams()
 *   navigateTo('/stocktake')                          // preserves current params
 *   navigateTo('/orders', { tab: 'to-receive' })      // preserves + appends tab
 */
export function useNavigateWithParams() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  return function navigateTo(
    path: string,
    extra?: Record<string, string>,
  ): ReturnType<typeof navigate> {
    const next = new URLSearchParams(searchParams)
    if (extra) {
      for (const [k, v] of Object.entries(extra)) {
        next.set(k, v)
      }
    }
    const qs = next.toString()
    return navigate(qs ? `${path}?${qs}` : path)
  }
}
